import { OpenRollfiPayroll } from '../../../domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteOpenRollfiPayroll extends BaseHttpService<OpenRollfiPayroll.Model> implements OpenRollfiPayroll {
  async openRollfiPayroll(body: OpenRollfiPayroll.Params): Promise<OpenRollfiPayroll.Model> {
    return await this.request('post', body);
  }
}
